if(jQuery('.page-template-template-newsletter').length) {

    jQuery('.tnp-subscription').customselect({

        style:'list',
        dropdown:false,
        search:false,

    });  

}